export default __webpack_public_path__ + "static/media/2.51da8046.jpg";